<div class="stage gutter">
    
    <section class="slide flx-dynamic" id="slide0">
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img1.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img1.png">
                </picture>
            </div>
        </div>
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content nopad slide-content--1">
                <div class="slide-content-box mb">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>W kilku słowach</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>Jesteśmy producentem wielofunkcyjnych przyczep bagażowych oraz przyczep specjalistycznych do przewozu samochodów, pojazdów budowlanych, motocykli, quadów oraz łodzi.</p>
                    </div>
                </div>
                <div class="slide-content-box">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>Jakość i bezpieczeństwo</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>Szeroka oferta licząca blisko 300 modeli z możliwością konfiguracji i doboru funkcjonalnych opcji. Dbamy by wszystkie charakteryzowały się najwyższą jakością i gwarantowały bezpieczeństwo użytkowania.</p>
                    </div>
                </div>
            </div>
        </div>
        <a href="#slide2" class="scroll-link"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>
    
    <section class="slide flx-dynamic" id="slide1">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content nopad slide-content--1">
                <div class="slide-content-box mb">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>Skala robi wrażenie</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>Przyczepy Temared można spotkać w każdym zakątku świata. Współpracujemy z ponad 300 dystrybutorami w 57 krajach na 6 kontynentach.</p>
                    </div>
                </div>
                <div class="slide-content-box">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>Ćwierć miliona przyczep</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>W 2023 wyprodukowaliśmy 50 000 przyczep, a od początku działalności z naszych zakładów wyjechało ich już 300 000.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img2.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img2.png">
                </picture>
            </div>
        </div>
        <a href="#slide2" class="scroll-link"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>   
    
    <section class="slide flx-dynamic" id="slide2">
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img3.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img3.png">
                </picture>
            </div>
        </div>
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content nopad slide-content--2">
                <div class="slide-content-box mb">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>Mierzymy wysoko</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>Chcemy być największym producentem przyczep w Europie i uplasować się na pozycji lidera lub co najmniej wicelidera na każdym z rynków europejskich.</p>
                    </div>
                </div>
                <div class="slide-content-box">
                    <h2 class="slide-content-title flx-col"><span class="line-inner" i18n>Jesteśmy doceniani</span></h2>
                    <div class="slide-content-wrap">
                        <p class="content-txt" i18n>W 2024 roku firma po raz piąty otrzymała nagrodę Diament Forbes dla najdynamiczniej rozwijających się polskich firm.</p>
                    </div>
                </div>
            </div>
        </div>
        <a href="#slide0" class="scroll-link"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-up"></use></svg></a>
    </section>    

</div>